import Vue from 'vue'
import Router from 'vue-router'

// firms
const FirmsSearch = () => import('@/views/firms/search')

Vue.use(Router)

const router = new Router({
  mode: 'history',
  scrollBehavior() {
    return {
      x: 0,
      y: 0
    }
  },
  base: process.env.BASE_URL,
  routes: [
    {
      path: '*',
      component: FirmsSearch,
      name: 'firmSearch'
    }
  ]
})

export default router
